export const nameMaxLength = 254;
export const nameMaxLengthValidation = (maxLength: number = nameMaxLength) =>
  `Name must be a string with a maximum length of ${maxLength}`;
export const descriptionMaxLength = 4000;
export const descriptionMaxLengthValidation = (maxLength: number = descriptionMaxLength) =>
  `Description must be a string with a maximum length of ${maxLength}`;
export const requiredFieldValidation = "Must be filled out.";
export const genericError = "Error";
export const listLoadFailedError = "Failed to load list of configurations";
export const defaultUserGroupDescription = (userGroupId: number) => `User group ${userGroupId}`;
export const defaultUserTypeDescription = (userTypeId: number) => `User type ${userTypeId}`;
export const applicabilityMatrixError = "Couldn't load applicability matrix";
export const applicablityAccessError =
  "Highlighted applicabilities do not exist or you do not have access to them.";
